module.exports = __webpack_public_path__ + "media/images/shared/bgi-js-model-travel-f9ffed03d8ff344082525557101d78d5.jpg";